import themeGet from '@styled-system/theme-get';
import { PricelineSparkle } from 'pcln-icons';
import React from 'react';
import styled, { css } from 'styled-components';
import { Absolute } from '../Absolute/Absolute';
import { Flex } from '../Flex/Flex';
import { Text } from '../Text/Text';
import { applyVariations, getPaletteColor, getTextColorOn } from '../utils/utils';
const variations = {
  initial: css(["margin-left:", ";"], themeGet('space.3')),
  incoming: css(["border-top-left-radius:4px;"]),
  outgoing: css(["background-color:", ";border-top-right-radius:4px;color:", ";justify-content:flex-end;"], getPaletteColor('primary.base'), getTextColorOn('primary.base'))
};
const Message = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "ChatMessage__Message",
  componentId: "sc-kwmeww-0"
})(["position:relative;background-color:", ";color:", ";justify-content:flex-start;width:fit-content;", ";"], getPaletteColor('background.light'), getTextColorOn('background.light'), applyVariations('ChatMessage', variations));
/**
 * @public
 */
export const ChatMessageVariations = ['initial', 'incoming', 'outgoing'];
/**
 * @public
 */
export function ChatMessage({
  footer,
  header,
  Icon = PricelineSparkle,
  message,
  variation,
  ...props
}) {
  const marginTop = header ? 3 : 0;
  const marginBottom = footer ? 3 : 0;
  const footerPosition = variation === 'outgoing' ? {
    right: 0
  } : {
    left: 0
  };
  return React.createElement(Message, {
    borderRadius: '18px',
    variation: variation,
    mt: marginTop,
    mb: marginBottom,
    p: '12px',
    ...props
  }, header && React.createElement(Absolute, {
    top: '-20px',
    left: '0px',
    minWidth: '300px',
    width: '100%',
    px: 3
  }, header), variation === 'initial' && React.createElement(Absolute, {
    top: -16,
    left: -16
  }, React.createElement(Flex, {
    alignItems: 'center',
    borderRadius: 'full',
    color: 'primary',
    justifyContent: 'center',
    height: '32px',
    width: '32px'
  }, React.createElement(Icon, {
    color: 'text.lightest',
    size: '24px',
    "data-testid": 'chat-message-icon'
  }))), React.createElement(Text, {
    textStyle: 'paragraph2'
  }, message), footer && React.createElement(Absolute, {
    bottom: '-20px',
    minWidth: '300px',
    width: '100%',
    px: 3,
    ...footerPosition
  }, footer));
}